/**
 * F-047: Incoming ordered-orders count badge for the admin sidebar Orders nav item.
 *
 * Pure display component. Calls useIncomingOrdersCount internally.
 * Renders null at count 0 (AC3). Shows exact count 1–99 or '99+' (AC2).
 * Uses ms-auto for RTL-safe positioning (AC9).
 */
import { useTranslation } from '@dukanti/shared';
import { useIncomingOrdersCount } from '@/hooks/use-incoming-orders-count';

interface OrdersNavBadgeProps {
  userId: string | null;
}

export function OrdersNavBadge({ userId }: OrdersNavBadgeProps) {
  const { t } = useTranslation();
  const { count, displayCount } = useIncomingOrdersCount(userId);

  if (count === 0) return null;

  const ariaLabel =
    count >= 100
      ? t('admin.orders.badge.ariaLabelCapped')
      : t('admin.orders.badge.ariaLabel', { count });

  return (
    <span
      className="bg-terracotta ms-auto inline-flex h-5 min-w-5 items-center justify-center rounded-full px-1 text-[10px] font-semibold leading-none text-white"
      aria-label={ariaLabel}
      data-testid="orders-nav-badge"
    >
      {displayCount}
    </span>
  );
}
